import { camelCase } from 'lodash'
import isNil from 'lodash/isNil'
import moment from 'moment'

import { track, trackingEvents } from 'modules/core/lib/Tracking'

import type { InboxRequest } from '../hooks/useNotificationsRequests'

export function trackNotificationEvent(request: InboxRequest, index: number, dashboard = false) {
  const dueDate = moment(request.dueDate)

  const dueSince = isNil(dueDate)
    ? undefined
    : moment().startOf('day').diff(dueDate.startOf('day'), 'days')

  const dashboardTracking = {
    page_path: '/dashboard',
    from: 'dashboard',
  }

  const inboxTracking = {
    page_path: '/inbox/requests',
    from: 'inbox_request',
  }

  track(trackingEvents.inbox.requests.goToRequest, {
    ...(dashboard ? dashboardTracking : inboxTracking),
    task_type: camelCase(String(request.type)),
    due_since: dueSince,
    index,
  })
}
